<script lang="ts">
  export let text: string | null;
  export let isLegalField: boolean = false;
</script>

<div class="RichTextField" class:isLegalField>{@html text}</div>

<style>
  div {
    --color: var(--color-text);
    --font-size: var(--font-size-16);
    --line-height: var(--line-height-28);

    &.isLegalField {
      --color: var(--color-gray);
      --font-size: var(--font-size-14);
      --line-height: var(--line-height-24);
    }
  }
</style>
